// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"13":"4408b6e7","121":"55d02103","167":"79c2843e","242":"3e903061","524":"1d7aca49","620":"29b69d35","761":"295c0916","773":"d9f1d9f1","847":"72d36b5f"}[chunkId] + ".chunk.js";
};